import script from "./HistoryRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryRecord.vue?vue&type=script&setup=true&lang=js"

import "./HistoryRecord.vue?vue&type=style&index=0&id=ecb49b94&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecb49b94"]])

export default __exports__